import { statistics } from './statistics';

export const facebook = {
  statistics,
};
